import { DecodeHtml } from "../../utils/decodeHtml"

const AnnouncementCard = ({ img, title, date, content }) => {
    return (
        <div className="p-4 w-full lg:p-8 bg-white border shadow rounded">
            <div className="w-full place-items-center md:place-items-start grid grid-cols-1 lg:grid-cols-[20%_65%] gap-10">
                <div className="w-[20rem] md:w-full relative h-[25rem] md:h-full  max-h-[25rem] bg-gray-100 bg-center bg-cover bg-no-repeat" style={{ backgroundImage: `url('${img}')` }}>

                </div>
                <div className="w-full flex flex-col items-center mb-12 lg:items-start gap-5">
                    <div className="flex flex-col items-center lg:items-start gap-1">
                        <h2 className="w-auto  text-slate-900 text-2xl md:text-3xl font-bold ">{title}</h2>
                        <span className="w-auto  text-[#0039CB]  font-bold ">published on {
                            new Date(date).toLocaleDateString(
                                'en-US',
                                {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                }
                            )
                            
                            }</span>
                    </div>

                    <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal whitespace-pre-line ">{DecodeHtml({ html: content })}</p>
                </div>
            </div>
        </div>
    )
}

export default AnnouncementCard